import React from 'react'
import {
  DropdownOptionProps,
  DropdownTheme,
  DatePickerInputFirstDayOfWeek,
  Dropdown,
} from 'wix-ui-tpa/cssVars'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'

import {LayoutSize} from '../../../../components-shared/LayoutSizeProvider/types'
import {LazyDatePicker} from '../../../../components-shared/LazyDatePicker'
import {getFirstDayOfWeek, parseLocaleFromBM} from '../../../../utils/locale'

import {classes, st} from './Form.st.css'

type DefaultOptions = DropdownOptionProps[]
type DefaultOnChange = (option: DropdownOptionProps) => void

interface Props {
  layoutSize: LayoutSize
  regionalSettings?: string
  partySize: {
    value: string
    options: DefaultOptions
    onChange: DefaultOnChange
  }
  date: {
    value?: Date
    filterDate: (date: Date) => boolean
    onChange: (date: Date) => void
  }
}

export const Form = ({layoutSize, partySize, date, regionalSettings}: Props) => {
  const {t} = useTranslation()
  const {isSSR} = useEnvironment()
  const locale = parseLocaleFromBM(regionalSettings)

  const weekFirstDay = getFirstDayOfWeek(locale) as DatePickerInputFirstDayOfWeek

  return (
    <div className={st(classes.root, {[layoutSize]: true})}>
      <Dropdown
        className={st(classes.partySizeDropdown)}
        upgrade
        label={t('uou-reservations.reservations.party')}
        initialSelectedId={partySize.value}
        options={partySize.options}
        onChange={partySize.onChange}
        theme={DropdownTheme.Box}
      />

      <LazyDatePicker
        firstDayOfWeek={weekFirstDay}
        label={t('uou-reservations.reservations.date')}
        value={isSSR ? undefined : date.value}
        filterDate={date.filterDate}
        onChange={date.onChange}
        datePickerClass={st(classes.datePicker)}
        dateTextFieldClass={st(classes.datePicker)}
        dateTextFieldDataHook="experience-date-picker"
        excludePastDates
      />
    </div>
  )
}
